import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  Container,
  Table,
} from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaRegCirclePlay } from "react-icons/fa6";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";

const Pricing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container fluid className="p-0" >
     
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b>-boost your SEO
            game&nbsp;&nbsp;{" "}
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>
      {/* start */}
      <div className="container p-0">
        <div className=" mt-3">
          <div className="row mx-md-0 mx-3 mt-sm-3">
            <div className="col-md-1"></div>
            <div className="col m-0 p-0">
              <h1
                style={{
                  // fontFamily: "'Playfair Display', serif",
                  fontSize: "2.5rem",
                }}
                className="mt-2 mb-3 text-center"
              >
                <b>Plans & Pricing</b>
              </h1>

              <Pricingcard />
              <Addonprice />
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
      {/* end */}
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};
const Pricingcard = () => {
  const [plans, setPlans] = useState([]);
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [modalVideo, setModalVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetPricingPlans();
  }, []);

  const GetPricingPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Seo/GetPricingPlans`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SEO data.");
      }

      const data = await response.json();
      if (data.status === "0" && data.data) {
        const formattedPlans = data.data.map((plan) => ({
          name: plan.plan_name,
          price: plan.amount,
          duration: plan.duration,
          description: plan.desc1,
          features1: plan.features1,
          features2: plan.features2,
          features3: plan.features3,
          features4: plan.features4,
          heading: plan.heading,
          desc2: plan.desc2,
          features: plan.data.map((feature) => ({
            text: feature.description,
            video: feature.video_url || null,
          })),
          buttonText: "Subscribe",
        }));

        setPlans(formattedPlans);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js"; 
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/loader.gif")} alt="seobix" />
        </div>
      ) : (
        <>
          <Row className="justify-content-center">
            {plans.map((plan, index) => (
              <Col key={index} md={6} lg={4} className="mb-4">
                <Card className="shadow-sm h-100">
                  <Card.Body className="p-4">
                    <h5 className="mb-1">
                      <b>{plan.name}</b>
                    </h5>
                    <h3>
                      <b>{plan.price}</b>/
                      <span style={{ fontSize: "1rem" }}>{plan.duration}</span>
                    </h3>
                    <Button
                      className="mt-2 mb-2"
                      style={{ width: "100%" }}
                      onClick={() => {
                        const planNameEncoded = encodeURIComponent(plan.name);
                        const registerUrl = `https://dashboard.seobix.com/Register?plan=${planNameEncoded}`;
                        window.open(registerUrl, "_blank");
                      }}
                    >
                      {plan.buttonText}
                    </Button>
                    <p className="text-muted mb-2 mt-3">
                      <b>{plan.description}</b>
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features1}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features2}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features3}
                    </p>
                    <p>
                      <FaCheck style={{ color: "green" }} /> &nbsp; &nbsp;
                      {plan.features4}
                    </p>
                    <h6>
                      <b>{plan.heading}</b>
                    </h6>
                    <p
                      className="text-muted mb-2 mt-3"
                      style={{ fontWeight: "500" }}
                    >
                      {plan.desc2}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <h3 className="mb-3 mt-2">Compare Plans</h3>
          <Row>
            {plans.map((plan, index) => (
              <Col key={index} md={6} lg={4} className="mb-2">
                <h5 className="mb-1">
                  <b>{plan.name}</b>
                </h5>
                <hr />
                <ul className="list-unstyled">
                  {plan.features.map((feature, idx) => (
                    <li
                      key={idx}
                      onMouseEnter={() => setHoveredFeature(feature.text)}
                      onMouseLeave={() => setHoveredFeature(null)}
                      onClick={() => {
                        if (feature.video) {
                          setModalVideo(feature.video);
                          setShowModal(true);
                        }
                      }}
                      style={{
                        position: "relative",
                        cursor: feature.video ? "pointer" : "default",
                        color: feature.video ? "#007bff" : "black",
                      }}
                    >
                      <Row className="pt-0 pb-0">
                        <Col md={10}>
                          <p>{feature.text}</p>
                        </Col>
                        <Col>
                          <FaRegCirclePlay style={{ color: "lightgray" }} />
                        </Col>
                      </Row>
                      {hoveredFeature === feature.text && feature.video && (
                        <video
                          src={feature.video}
                          autoPlay
                          muted
                          loop
                          onClick={(e) => {
                            e.stopPropagation();
                            setModalVideo(feature.video);
                            setShowModal(true);
                          }}
                          style={{
                            position: "absolute",
                            left: "80%",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "180px",
                            height: "100px",
                            borderRadius: "5px",
                            boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                            zIndex: 10,
                            backgroundColor: "white",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </li>
                  ))}
                </ul>
              </Col>
            ))}
          </Row>

          {/* Video Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Body className="p-0">
              {modalVideo && (
                <video
                  src={modalVideo}
                  controls
                  autoPlay
                  style={{ width: "100%", borderRadius: "5px" }}
                />
              )}
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};
const Addonprice = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    GetPricingPlansAddOn();
  }, []);

  const GetPricingPlansAddOn = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Seo/GetPricingPlansAddOn`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SEO data.");
      }

      const data = await response.json();
      if (data.status === "0" && data.data) {
        const formattedPlans = data.data.flatMap((category) =>
          category.data.map((addon) => ({
            id: addon.id,
            heading: addon.heading2,
            description: addon.desc,
            basic: addon.basic_desc,
            standard: addon.standard_desc,
            premium: addon.premium_desc,
          }))
        );
        setPlans(formattedPlans);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/loader.gif")} alt="seobix" />
        </div>
      ) : (
        <div>
          <hr className="" />
          <h2 className="mb-3">Addon Pricing</h2>
          <Table>
            <thead>
              <tr>
                <th style={{ width: "40%" }}>Feature</th>
                <th style={{ width: "20%" }}>Basic</th>
                <th style={{ width: "20%" }}>Standard</th>
                <th style={{ width: "20%" }}>Premium</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((addon) => (
                <tr key={addon.id}>
                  <td>
                    <strong>{addon.heading}</strong>
                    <p>{addon.description}</p>
                  </td>
                  <td>
                    {addon.basic}
                    <br /> <br />
                    <Button
                      size="sm"
                      style={{
                        color: "green",
                        background: "#fff",
                        border: "1px solid green",
                      }}
                    >
                      Buy Now
                    </Button>
                  </td>
                  <td>
                    {addon.standard} <br /> <br />
                    <Button
                      size="sm"
                      style={{
                        color: "green",
                        background: "#fff",
                        border: "1px solid green",
                      }}
                    >
                      Buy Now
                    </Button>
                  </td>
                  <td>
                    {addon.premium} <br /> <br />
                    <Button
                      size="sm"
                      style={{
                        color: "green",
                        background: "#fff",
                        border: "1px solid green",
                      }}
                    >
                      Buy Now
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default Pricing;
